import TrainingCompanySignIn from "pages/LandingPages/TrainingCompanySignIn/TrainingCompanySignIn";

export default function TrainingCompanySignInPage() {
  return <TrainingCompanySignIn />;
}
